import axios from "../axiosInstance"
import { empresas } from "../shared/utils/Endpoints"

class EmpresasService {
    async listarEmpresas() {
        return await axios.get(empresas, { cache: true })
    }
}

export default new EmpresasService();